import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {isConnected} from '/redux/selector/network.selector';

import {NetInfoProvider as BaseNetInfoProvider} from './NetInfoProvider';

export const NetInfoProvider = connect(
  createStructuredSelector({isConnected}),
  {},
)(BaseNetInfoProvider);
